var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99922 4.00078V5.60078H9.99922V4.00078C9.99922 2.89578 9.10422 2.00078 7.99922 2.00078C6.89422 2.00078 5.99922 2.89578 5.99922 4.00078ZM4.79922 5.60078V4.00078C4.79922 2.23328 6.23172 0.800781 7.99922 0.800781C9.76672 0.800781 11.1992 2.23328 11.1992 4.00078V5.60078C12.0817 5.60078 12.7992 6.31828 12.7992 7.20078V12.8008C12.7992 13.6833 12.0817 14.4008 11.1992 14.4008H4.79922C3.91672 14.4008 3.19922 13.6833 3.19922 12.8008V7.20078C3.19922 6.31828 3.91672 5.60078 4.79922 5.60078ZM9.99922 6.80078H5.99922H4.79922C4.57922 6.80078 4.39922 6.98078 4.39922 7.20078V12.8008C4.39922 13.0208 4.57922 13.2008 4.79922 13.2008H11.1992C11.4192 13.2008 11.5992 13.0208 11.5992 12.8008V7.20078C11.5992 6.98078 11.4192 6.80078 11.1992 6.80078H9.99922Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.550ffc8358e32e54b7c0e2ea99be723f.svg";
export { ForwardRef as ReactComponent };